import React, { useState, useContext, Fragment, useEffect } from "react";
import Traductor from "../Traductor";
import Button from "../bronson/Button";
import ParseService from "../../services/ParseService";
import Globals from "../../Globals";
import TransportService from "../../services/TransportService";
import PreferenceModule from "../PreferenceModule";
import { withCookies } from "react-cookie";
import { formatPrice } from "../../js/components/shared/vehicleFunctions";
import { UserContext } from "../../contexts/UserContext";
import { Destination } from '../../models/Destination.js'
import { disableHTMLOverflow } from '../../Functions';
import ToastNotification from '../bronson/ToastNotification';


function PopupUpdatePriceVehicleNotBuy({ cookies, vehicle, closeModal, transportRequest }) {
  const { user } = useContext(UserContext);
  const t = new Traductor();
  const [validateForm, setValidateForm] = useState(false);
  const [transportData, setTransportData] = useState({});
  const [isDownload, setIsDownload] = useState(false);
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    disableHTMLOverflow(true);
  }, [])

  const updateDataTransport = (dataTransport) => {
    setTransportData(dataTransport);
  }

  const getTransportData = async (dataTransport) => {
    if (dataTransport != null) {
      var dealerName = "";
      if (dataTransport.CodconsesionarierBuyer && user.data && user.data.Dealers &&
        user.data.Dealers.find(d => d.Id === dataTransport.CodconsesionarierBuyer)) {
        dealerName = user.data.Dealers.find(d => d.Id === dataTransport.CodconsesionarierBuyer).Name;
      }
      var destination = new Destination();
      Object.preventExtensions(destination);
      destination.UbicationId = dataTransport.CodconsesionarierBuyer;
      destination.UbicationType = dataTransport.CodconsesionarierBuyer !== "" ? 3 : 0;
      destination.LocationId = transportData.DestinationLocationId;
      destination.Name = dealerName;
      destination.AddressType = dataTransport.StreetType;
      destination.Address = dataTransport.StreetName;
      destination.AddressNumber = dataTransport.StreetNumber;
      destination.PostalCode = dataTransport.ZipCode;
      destination.ProvinceCode = dataTransport.ZipCode.substring(0, 2);
      destination.ProvinceName = dataTransport.ProvinceName;
      destination.MunicipalityCode = dataTransport.CodePoblation;

      transportRequest.PreferencesContext = dataTransport;
      transportRequest.TransportRequest.TransportPrice = transportData.TransportPrice;
      transportRequest.Vehicle = vehicle;
      transportRequest.BuyData = {
        Destination: destination,
        Term: transportData.Term,
        TransportPrice: transportData.TransportPrice,
        BuyerData: user.cifs.find(x => x.CIF === dataTransport.CifBuyer)
      }

      let newDestination = "--";
      if (dataTransport.CodconsesionarierBuyer !== null && dataTransport.CodconsesionarierBuyer != "") {
        let dealerSelected = user.data.Dealers.find(u => u.Id === dataTransport.CodconsesionarierBuyer);
        if (dealerSelected) {
          newDestination = dealerSelected.Name;
        }
      }
      else if (dataTransport.ProvinceName !== "") {
        newDestination = dataTransport.ProvinceName;
      }
      if (isDownload) {
        await new TransportService().DownloadProformaPDF(cookies.get(Globals.COOKIES.JWT).AccessToken, transportRequest);
        setIsDownload(false);
        setShowToast({ title: '¡Descarga completada!', text: 'La proforma PDF se ha descargado correctamente', type: 'success', closeText: 'Cerrar', timeout: false });
      }
      else {
        await new TransportService().UpdateDataTransportSolicitude(cookies.get(Globals.COOKIES.JWT).AccessToken, transportRequest).then(
          (response) => {
            if (response && response.Result) {
              let correctSave = new ParseService().Parse(response.Result);
              if (correctSave === true) {
                return closeModal({
                  newDestination: newDestination,
                  newTransportPrice: transportData.TransportPrice,
                  newDealerEstadistics: dataTransport.DealerEstadistics,
                  newBrandExposition: dataTransport.BrandExposition
                });
              }
            }
            const errorText = Array.isArray(response?.Errors)
              ? response.Errors.find((e) => e?.Value)?.Value
              : response?.Errors?.Value || response?.Message;

            if (errorText) {
              setShowToast({
                title: "¡Error!",
                text: errorText.toString(),
                type: "error",
                closeText: "Cerrar",
                timeout: false
              });
            } else {
              alert("No se ha podido actualizar los datos de transporte");
            }
          })
      }
    }
  }

  let optionsBtnUpdatePriceSolicitude = {
    text: t.getTraduction("BtnActualizarPrecioSolicitudTransporte"),
    value: "Actualizar Precio",
    id: "btnUpdatePrice",
    class: "c-btn  js-modal-close  js-modal-autofocus"
  };
  let optionsBtnDownloadPDFProforma = {
    text: t.getTraduction("BtnDownloadPDFProforma"),
    value: "Actualizar Precio",
    id: "btnDownloadPDF",
    icon: {
      title: 'download',
      image: 'semantic-download',
      isAfterText: true,
    },
    class: 'c-btn  c-btn--secondary  c-btn--icon u-mr',
  };

  function showprice() {
    return (
      <div className="o-fieldset__row u-mt rema-border-d8">
        <div className="o-layout">
          <div className="o-layout__item u-1/1">
            <p className="u-h3">{t.getTraduction("PriceMax")}</p>
          </div>
          <div className="o-layout__item u-1/2 u-p-none u-mt">
            <p>{t.getTraduction("Vehicle")}</p>
          </div>
          <div className="o-layout__item u-1/2 u-p-none u-mt u-text-right">
            <p><strong>
              {!isNaN(vehicle.Price)
                ? formatPrice(vehicle.Price)
                : "--"}
            </strong></p>
          </div>
          {!isNaN(transportData.TransportPrice) && transportData.TransportPrice > 0 &&
            <Fragment>
              <div className="o-layout__item u-1/2 u-p-none u-mt-none">
                <p>{t.getTraduction("Transport")}</p>
              </div>
              <div className="o-layout__item u-1/2 u-p-none u-mt-none u-text-right">
                <p><strong>
                  {!isNaN(transportData.TransportPrice)
                    ? formatPrice(transportData.TransportPrice)
                    : "--"}
                </strong></p>
              </div>
            </Fragment>
          }
          <hr />
          <div className="o-layout__item u-1/2 u-p-none u-mt-none">
            <p><strong>{t.getTraduction("Total")}</strong></p>
          </div>
          <div className="o-layout__item u-1/2 u-p-none u-mt-none u-text-right">
            <p><strong>
              {!isNaN(transportData.TransportPrice) && transportData.TransportPrice > 0 ?
                !isNaN(vehicle.Price + transportData.TransportPrice)
                  ? formatPrice(vehicle.Price + transportData.TransportPrice)
                  : "--"
                : formatPrice(vehicle.Price)}
            </strong></p>
          </div>
        </div>
      </div>
    )
  };

  function printPreferenceModule() {
    if (transportRequest.PreferencesContext) {
      return (
        <PreferenceModule
          data={transportRequest.PreferencesContext}
          options={{
            button: {
              function: getTransportData,
              reset: setValidateForm
            },
            transport: {
              selectedVehicle: vehicle,
              getTransport: true,
              function: updateDataTransport,
              userHasTransportAvailable: vehicle.CodeBuyType === "R" ? false : true
            }
          }}
          parentSubmit={validateForm}
        ></PreferenceModule>
      )
    }
    else {
      return null;
    }
  };

  const onSubmit = async () => {
    setValidateForm(true);
  }

  const onDownload = async () => {
    try {
      setIsDownload(true);
      await onSubmit(true);

    } catch (err) {
      console.error(err);
      setShowToast({ title: '¡Error!', text: 'Error al descargar la proforma', type: 'error', closeText: 'Cerrar', timeout: false });
    }
  };


  const closeThisModal = (value) => {
    disableHTMLOverflow(false);
    closeModal(value);
  }

  return (
    <Fragment>
      {showToast && <ToastNotification options={showToast} closeToast={() => setShowToast(null)} />}
      <div
        className="c-modal c-modal--advanced-filters c-vehicle-filters--advanced" id="demo-modal">
        <div className="c-modal__overlay  js-modal-close" tabIndex="-1"></div>
        <div className="c-modal__wrapper" role="dialog">
          <header className="c-modal__header">
            <div className="c-modal__title__wrapper">
              <p className="u-h4 c-modal__title">
                {t.getTraduction("ModalUpdatePriceVehicle_Title")}
              </p>
            </div>
            <button
              className="c-modal__close-btn  js-modal-close"
              onClick={() => closeThisModal({})}
              type="button"
              aria-label="Cerrar modal."
            ></button>
          </header>
          <div className="c-modal__content" role="document">
            <div className="c-accordion  js-accordion  js-is-fx" data-accordion-multiple="true">
              {printPreferenceModule()}
              {showprice()}
            </div>
          </div>
          <div className="c-modal__footer">
            <div className="c-modal__actions">
              <div className="c-modal__actions__item">
                <button className="c-btn c-btn--secondary js-modal-close" aria-label="Cerrar modal." onClick={() => closeThisModal({})}>
                  <span className="c-btn__text">
                    {t.getTraduction("Cancelar")}
                  </span>
                </button>
              </div>
              <div className="c-modal__actions__item">
                <Button
                  options={optionsBtnUpdatePriceSolicitude}
                  onClick={onSubmit}
                ></Button></div>
              <div className="c-modal__actions__item">
                <Button
                  options={optionsBtnDownloadPDFProforma}
                  onClick={onDownload}
                ></Button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default withCookies(PopupUpdatePriceVehicleNotBuy);
